import React from 'react';

const DetailItem = ({ width, item, detail }) => {
  return (
    <div className='mb-2' style={{ marginBottom: 2, display: 'flex' }}>
      <div
        className='has-text-weight-semibold'
        style={{ width, flexShrink: 0 }}
      >
        <span className='flex justify-between align-center'>
          <span>{item}</span>
          <span>:</span>
        </span>
      </div>
      <div className='pl-1' style={{marginTop: 1}}>{detail}</div>
    </div>
  );
};

export default DetailItem;
